import { ValueOf } from '../utilities/types';

const resourceNames = {
  ACCOUNT_ENTITIES: 'account-entities',
  API_KEYS: 'access-management/api-keys',
  AUDIT_TRACKS: 'audit-tracks',
  BANK_DATA: 'bank-data',
  BUSINESSES: 'businesses',
  CARS: 'cars',
  CASES: 'cases',
  CONNECTIONS: 'connections',
  DATA_POINT_SOURCES: 'data-point-sources',
  DATA_POINTS: 'data-points',
  DEVICE_USAGES: 'device-usages',
  FORM_ANSWERS: 'form-answers',
  FORMS: 'forms',
  GROUPS: 'groups',
  INDIVIDUALS: 'individuals',
  INTERFACE_SETTINGS: 'interface-settings',
  IP_USAGES: 'ip-usages',
  MEMBERS: 'access-management/members',
  PERMISSION_ROLES: 'access-management/permission-roles',
  PINGS: 'pings',
  PINGU_CHAT: 'chat',
  PINGU_SESSIONS: 'chat/sessions',
  PROCESSES: 'processes',
  PRODUCTS: 'products',
  REPORTS: 'reports',
  REQUESTS: 'requests',
  REVIEWS: 'reviews',
  RISK_CLASSES: 'risk-classes',
  RULE_VERSION: 'rule-version',
  RULES: 'rules',
  SCORES: 'scores',
  SIGNALS: 'signals',
  TAGS: 'tags',
  TRANSACTION_TYPES: 'transaction-types',
} as const;

export type ResourceNames = ValueOf<typeof resourceNames>;

export default resourceNames;
